import store from './../../store'
import notificationTransformer from '../../transformers/notification'
import Vue from 'vue'

const newAlert = (val) => {
  store.dispatch('alerts/ReciveAlert', val)
}

export default () => {
  const token = store.state.auth.accessToken
  const protocolPrefix = location.protocol === 'http:' ? 'ws' : 'wss'
  const address = Vue.config.debug ? process.env.NOTIFICATIONS_SOCKET : location.host

  if (!Vue.notificationSocket) {
    const notificationSocket = new WebSocket(
        `${protocolPrefix}://${address}/ws/notifications/?token=${token}`,
      )
    notificationSocket.onmessage = function (e) {
      const data = JSON.parse(e.data)
      if (data.data) {
        if (data.data.type === 'sinister') {
          newAlert(notificationTransformer.notificationSinister.fetch(data))
        } else if (data.data.type === 'sinisters') {
          newAlert(notificationTransformer.notificationSinisters.fetch(data))
        } else if (data.data.type === 'custom') {
          newAlert(notificationTransformer.customNotification.fetch(data))
        } else {
          newAlert(notificationTransformer.notification.fetch(data))
        }
      } else {
        newAlert(notificationTransformer.notification.fetch(data))
      }
    }

    notificationSocket.onclose = function (e) {
      Vue.notificationSocket = null
    }
    notificationSocket.onerror = function (e) {
      Vue.notificationSocket = null
    }


    Vue.notificationSocket = notificationSocket
    return notificationSocket
  }
  return null
}



// WEBPACK FOOTER //
// ./src/services/notification/connectSocket.js